import { LMModel } from '@form/model';
import {EventEmitter, Input, OnInit, Output, Directive, HostBinding, AfterViewInit} from '@angular/core';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLoggerService } from '@app/services';

export enum LMElementLayoutType {
  FIELD = 0,
  CHECK_CONTROL,
  HEADER,
  PARAGRAPH,
  BUTTON,
  BLANK,
  TEXT,
  MENU
}

@Directive()
export abstract class LMColumnsBaseComponent implements OnInit, AfterViewInit {
  public readonly instanceId: string;

  @Input() layoutObject: LMFormLayoutSection;
  @Input() specFields: any;
  @Input() model: LMModel;
  @Input() placeHolder: any;
  @Input() layoutInfo: LMFormLayoutInfo;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() parentIsModal: boolean;

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  @HostBinding('class.lm-column-layout') lmColumnLayout = true;
  @HostBinding('class.lm-summary-form') get lmSummaryForm() {
    return this.lmColumnLayoutInfo?.sectionInfo?.isSummaryFormSection;
  }
  @HostBinding('class.lm-number-label-section') get lmNumberLabelSection() {
    return this.lmColumnLayoutInfo?.sectionInfo?.sectionHasNumberLabel;
  }
  @HostBinding('class.lm-no-label-section') get lmNoLabelSection() {
    return this.lmColumnLayoutInfo?.sectionInfo?.isNoLabelSection;
  }

  protected constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService
  ) {
    this.subLayoutType = LMElementLayoutType;
    this.instanceId = this.lmLoggerService.instanceId;
  }

  ngOnInit() {
    if (this.lmLoggerService.cskLog === 2) {
      this.lmLoggerService.time({
        id: `Total-Column-Layout-${this.instanceId}`,
        description: 'TOTAL COLUMN LAYOUT',
        functionName: 'ngOnInit()',
        className: 'LMColumnsBaseComponent',
        timingStart: 'LMColumnsBaseComponent -> ngOnInit()',
        timingEnd: 'LMColumnsBaseComponent -> ngAfterViewInit()',
      });
    }

    this.lmColumnLayoutInfo.nbrColumns = this.layoutObject.nbrColumns;
  }

  ngAfterViewInit() {
    if (this.lmLoggerService.cskLog === 2) {
      this.lmLoggerService.timeEnd(`Total-Column-Layout-${this.instanceId}`);
    }
  }

  public columns: Array<LMFormLayoutColumnUi>;
  public rows: Array<LMFormLayoutElementsUi>;
  subLayoutType;

  public onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }

  public getType(element): string {
    return 'elementLayout.element' + Object.keys(element)[ 0 ].toString();
  }

  public getLayoutObject(element) {
    if (element) {
      return element[ Object.keys(element)[ 0 ] ];
    }

    return null;
  }

  public trackByIndex(index: number, column: LMFormLayoutColumn): number {
    return column.index;
  }

  public updateImplicitColumns() {
    if (this.lmFormLayoutService.columnsAreImplicit(this.layoutObject)) {
      const columns: Array<LMFormLayoutColumn> = this.lmFormLayoutService.buildImplicitColumns(this.layoutObject, this.model);

      // convert to string to compare for differences; if different, then use Date.now() to
      // have a unique number for the column.index so that trackBy will re-create the dom
      columns.forEach((column, index) => {
        const newColumnJson = JSON.stringify(column);
        const currentColumnJson = JSON.stringify(this.columns[index]);

        if (currentColumnJson !== newColumnJson) {
          column.index = Date.now();
        }
      });

      this.columns = [].concat(columns);
    }
  }

}
